import {Injectable, InjectionToken} from "@angular/core";
import {Observable} from "rxjs";
import {Role} from './role';
import {User} from '../model/user';
import {AuthenticationTokens} from '../model/authentication';
import {OrganizationType} from '../model';

@Injectable()
export abstract class AuthService {

  abstract registerWithEmail(payload: SignUpPayload): Observable<void>;

  abstract registerGhostMerchantWithEmail(payload: GhostMerchantSignUpPayload): Observable<void>;

  abstract registerGhostMerchantWithBounty(payload: GhostMerchantSignUpBountyPayload): Observable<void>;

  abstract verifyEmail(code: string): Observable<void>;

  abstract login(authAction: AuthenticationAction): Observable<void>;

  abstract logout(): Observable<void>;

  abstract getCurrentAccessToken(): Observable<string | null>;

  abstract refreshCurrentAccessToken(): Observable<string | null>;

  abstract getCurrentUser$(): Observable<User | undefined>;

  abstract getCurrentUser(): User | undefined;

  abstract reloadUser(): Observable<void>;

  abstract isCurrentUserVerified(): Observable<boolean | null>;

  abstract hasAuthenticatedUser(): boolean;

  abstract hasAuthenticatedUser$(): Observable<boolean>;

  abstract sendResetPasswordEmail(email: string): Observable<void>;

  abstract sendNewVerifyEmail(): Observable<void>;

  abstract resetPassword(code: string, newPassword: string): Observable<void>;

  abstract userHasRole(role: Role): boolean;


}

export enum AuthError {
  UNKNOWN,
  USER_ALREADY_EXIST,
  INVALID_CREDENTIALS,
  INVALID_EMAIL,
  INVALID_PASSWORD
}

export interface AuthConfig {
  publicEndpoints?: string[],
  notAuthenticatedRedirectRoute?: string,
  authenticatedRedirectRoute?: string
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('auth.config');

export interface AuthenticationPayload {
}

export interface AuthenticationAction {
  login(): Observable<AuthenticationTokens>;
}


export interface AuthenticationDispatcher {
  dispatch(state?: string): void;
}

export interface SignUpPayload {
  email: string;
  password: string;
  type: OrganizationType;
  invitationLinkId: string
}

export interface GhostMerchantSignUpPayload {
  email: string;
  password: string;
  invitationLinkId: string
}

export interface GhostMerchantSignUpBountyPayload {
  email: string;
  password: string;
  bountyId: string
}
